/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { AuthInit } from "./modules/Auth";
import { Routes } from "../app/Routes";
import { I18nProvider } from "../_metronic/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_metronic/layout";
import RedirectByDomain from "./RedirectByDomain";
import { getDatabaseNamePath } from "./config/config";
import NotificationPrompt from "./modules/Firebase/NotificationPrompt";
import { ToastContainer as ToastFcmContainer } from "react-toastify";
import VersionChecker from "./components/VersionChecker";

// ✅ Calcola basename dinamico in base al dominio
// const getBasename = () => {
//   const host = window.location.hostname;
//   const path = window.location.pathname;

//   if (host === 'agenti.roydermal.it') {
//     return 'roydermal'; // senza slash iniziale, perché già aggiunto in BrowserRouter
//   } else if (host === 'agenti.epspharma.it') {
//     return 'valderma';
//   } else if (host === 'localhost') {
//     return 'valderma';
//   }

//   // fallback per sviluppo locale
//   return ''; // basename = '/' → rotte normali
// };

export default function App({ store, persistor }) {
  const basename = getDatabaseNamePath(); // ✅ calcolato internamente
  return (
    /* Provide Redux store */
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
        {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
        <React.Suspense fallback={<LayoutSplashScreen />}>
          {/* Override `basename` (e.g: `homepage` in `package.json`) */}
          <BrowserRouter basename={"/" + basename}>
            {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
            <MaterialThemeProvider>
              {/* Provide `react-intl` context synchronized with Redux state.  */}
              <I18nProvider>
                {/* Render routes with provided `Layout`. */}
                <AuthInit>
                   <NotificationPrompt />
                   <VersionChecker />
                   
                  <RedirectByDomain />
                  <Routes />
                  <ToastFcmContainer />
                </AuthInit>
              </I18nProvider>
            </MaterialThemeProvider>
          </BrowserRouter>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
